module.exports = __webpack_public_path__ + "img/ali.81cc46ff.jpg";